import React from 'react';
import PropTypes from 'prop-types';

import Button from 'relements/build/esm/ui/button';
import ContextMenu from 'relements/build/esm/overlays/contextMenu';

import Icon from '@src/components/Icon';
import { isProduction } from '@src/utils';

import styles from './EditorHeader.scss';

function CodeEditorHeader({
  lastSaved,
  onSave,
  onRun,
  onClose,
  edited,
  canRun,
  noRun,
  onContextClick,
  envVariablesEnabled,
}) {
  const contextMenuRef = React.useRef();
  let lastSavedContent;
  let saveAlert;

  if (lastSaved) {
    lastSavedContent = (
      <p className={styles.editorHeaderSub}>Last Saved:{lastSaved}</p>
    );
  }

  if (edited) {
    saveAlert = (
      <p className={styles.editorAlert}>
        You have unsaved changes! Please save to run.
      </p>
    );
  }

  const handleContextMenuItemClick = React.useCallback(
    e => {
      if (contextMenuRef.current) contextMenuRef.current.handleClose(e);
      onContextClick(e);
    },
    [contextMenuRef.current]
  );

  return (
    <div className={styles.editorHeaderWrapper}>
      <div className={styles.editorHeaderChild}>
        <h4 className={styles.editorHeaderHeading}>Code Editor</h4>
        {lastSavedContent}
      </div>
      {saveAlert}
      <div
        className={`${styles.editorHeaderChild} ${styles.editorHeaderButtons}`}
      >
        {!noRun ? (
          <Button
            className={`${styles.buttonDefault} ${styles.saveBtn}`}
            onClick={onRun}
            disabled={!canRun}
          >
            Run
          </Button>
        ) : null}
        <Button
          className={`${styles.buttonDefault} ${styles.saveBtn}`}
          onClick={onSave}
          disabled={!edited || isProduction()}
        >
          Save
        </Button>
        <ContextMenu.Button
          ref={contextMenuRef}
          className={`${styles.buttonDefault}`}
          type={Button.TYPES.OUTLINE}
          size="medium"
          title="More"
          offset={{ top: 40, left: -20 }}
        >
          {envVariablesEnabled ? (
            <ContextMenu.Item
              size="medium"
              onClick={handleContextMenuItemClick}
            >
              Variables
            </ContextMenu.Item>
          ) : null}

          <ContextMenu.Item size="medium">
            Supported Libraries (coming soon)
          </ContextMenu.Item>
        </ContextMenu.Button>
        <Icon
          className={`${styles.closeBtn}`}
          onClick={onClose}
          iconType="close"
        />
      </div>
    </div>
  );
}

CodeEditorHeader.propTypes = {
  lastSaved: PropTypes.string,
  onSave: PropTypes.func,
  onRun: PropTypes.func,
  onClose: PropTypes.func,
  onContextClick: PropTypes.func,
  edited: PropTypes.bool,
  canRun: PropTypes.bool,
  noRun: PropTypes.bool,
  envVariablesEnabled: PropTypes.bool,
};

CodeEditorHeader.defaultProps = {
  lastSaved: '',
  onSave: () => {},
  onRun: () => {},
  onClose: () => {},
  onContextClick: () => {},
  edited: false,
  canRun: false,
  noRun: false,
  envVariablesEnabled: false,
};

export default CodeEditorHeader;
